<template>
    <div class="support-msa-section">
    <div class="support-wrapper">
        <div class="support-body">
            <div class="support-infos">
                <div class="timing-support">
                    <!-- SVG + span items here (unchanged) -->
                </div>
                <div class="mb-3">
                    <h3 v-if="shouldShowTitle == 1">Saisir les infos des personnes qui vous accompagneront.</h3>
                    <h3 v-else-if="shouldShowTitle == 0">
                        Joindre un document
                    </h3>
                    <h3 v-else>
                        Confirmer votre réservation
                    </h3>
                </div>
                <div v-if="edit_participants" class="d-flex" id="participants_bloc">
                        <div class="col-lg-10 d-flex gap-2">
                            <div class="field mb-3" v-for="(field, index) in this.participants_fields" :key="index">
                                <label class="form-label">{{field.name}} <span v-if="field.required">*</span> </label>
                                <input
                                :type="field.data_type"
                                class="form-control"
                                :placeholder="field.description ?? ''"
                                :field_name="field.internal_col_name"
                                :data-efs-id="field.efs_id"
                                />
                            </div>
                        </div>
                        <div class="col-lg-2 add-btn">
                            <button class="btn btn-primary nmb-3" type="button" @click="addParticipant">+</button>    
                        </div>
                </div>
                <div class="list-particip">
                    <div v-if="this.participants.length > 0" class="d-flex align-items-center justify-content-between">
                        <h5>Liste des participants</h5>
                    </div>
                    <div class="persons mt-3">
                        <div class="row g-3">
                            <div
                                class="col-md-6 col-lg-4"
                                v-for="(participant, index) in current_participants"
                                :key="index"
                            >
                                <div
                                    class="card h-100"
                                    :class="{ 'border-primary': selectedParticipant === index }"
                                    @click="set_selected_participant(index)"
                                    style="cursor: pointer;"
                                >
                                    <button
                                        @click.stop="removeParticipant(index)"
                                        class="btn-close position-absolute"
                                        style="width: 0.75rem; height: 0.75rem; padding: 0.25rem; top: 8px; right: 8px;"
                                        title="Retirer le participant"
                                        aria-label="Close">
                                    </button>
                                    <div class="card-body">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="column in participants_fields" :key="column.internal_col_name">
                                                <strong>{{ column.name }}:</strong>
                                                {{ participant[column.internal_col_name] || '—' }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- File Upload -->
                    <!-- <div v-if="!this.rdv_data.rdv_id && (this.prestations[0].allow_attachment == 1 || this.prestations[0].force_attachment)" class="file-upload-wrapper"> -->
                    <div v-if="shouldShowAttachment" class="file-upload-wrapper">
                        <label class="label mb-2">
                            {{ prestations[0].label_attachment ?? 'Joindre un fichier' }}
                            <span v-if="prestations[0].force_attachment" class="required">*</span>
                        </label>
                        <label v-if="!this.attachment" for="attachment" class="file-upload-label d-flex column align-items-start gap-1">
                            <input type="file" id="attachment" name="attachment" @change="setAttachment" class="d-none"/>
                            <svg fill="#000000" width="50px" height="50px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                <path d="M27,15v5a5,5,0,0,1-5,5H10a5,5,0,0,1-5-5V15a1,1,0,0,1,2,0v5a3,3,0,0,0,3,3H22a3,3,0,0,0,3-3V15a1,1,0,0,1,2,0ZM16,20a1,1,0,0,0,1-1V8.87l4.45,3a1,1,0,1,0,1.11-1.66l-6-4a1,1,0,0,0-1.11,0l-6,4a1,1,0,0,0,1.11,1.66l4.45-3V19A1,1,0,0,0,16,20Z"/>
                            </svg>
                            
                            <span class="file-text">
                                <strong>Sélectionnez un fichier ou faites un glisser-déposer ici</strong><br>
                                Aucun fichier choisi. La taille du fichier ne doit pas dépasser 2Mo.
                            </span>
                        </label>
                        <label v-else for="attachment" class="file-upload-label d-flex column align-items-start gap-1">
                            <svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 19L17 21L21 17M13 3H8.2C7.0799 3 6.51984 3 6.09202 3.21799C5.71569 3.40973 5.40973 3.71569 5.21799 4.09202C5 4.51984 5 5.0799 5 6.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.0799 21 8.2 21H12M13 3L19 9M13 3V7.4C13 7.96005 13 8.24008 13.109 8.45399C13.2049 8.64215 13.3578 8.79513 13.546 8.89101C13.7599 9 14.0399 9 14.6 9H19M19 9V13.5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            
                            <span class="file-text">
                                <strong>{{ `Fichier choisi: ${attachment.name}` }}</strong><br>
                                Appuyez sur la croix pour retirer le fichier
                            </span>
                             <button
                                type="button"
                                class="position-absolute btn-close"
                                style="width: 0.75rem; height: 0.75rem; padding: 0.25rem; top: 8px; right: 8px;"
                                @click.stop="handleRemoveFile"
                                aria-label="Supprimer le fichier"
                            ></button>
                        </label>
                    </div>
                    <!-- <AttachmentSection
                            v-if="shouldShowAttachment"
                            :attachment="attachment"
                            :prestation="prestations[0]"
                            @update:attachment="handleAttachmentUpdate"
                            class="full-width"
                    /> -->
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>
    import AttachmentSection from '../SharedComponents/AttachmentSection.vue';
    import axios from 'axios';

    export default {
        name: 'attendiesForm',
        components: {
            AttachmentSection
        },
        emits: ['participants-modify', 'update-attachment', 'can-submit'],
        props: [
            "rdv_data",
            "client_infos",
            "withAuth",
            "autoSelectNext",
            "price",
            "duration",
            'group_size',
            "prestations",
            "prestations_ids",
            "location",
            "agenda",
            "start_date",
            "config",
            'fo_config',
            'attendees'
        ],
        data() {
            return {
            prestations_fields: [],
            participants_fields: [],
            is_loading: false,
            rdv_requested: false,
            participants: [],
            selectedParticipant: null,
            error_message: null,
            attachment: null
            };
        },
        computed: {
            shouldShowAttachment() { //revoir ca if allow && force || allowattendies
                return this.prestations.length > 0 &&
                    (this.prestations[0].allow_attachment == 1 || this.prestations?.[0]?.allow_use_attach_for_attendees == 1);
            },
            shouldShowTitle() {
                const presta = this.prestations[0] || {};
                const forceAttachment = presta.force_attachment;
                const editParticipants = presta.edit_participants;
                const allowAttach = presta.allow_attachment;
                
                // Cacher le titre si force_attachment == 1 ET edit_participants == 0
                if (!editParticipants && (forceAttachment == 1 || allowAttach == 1)) {
                    return 0;
                } else if (!editParticipants && !allowAttach) {
                    return 2;
                }
                
                return 1;
            },
            current_participants: function(){
                return this.participants;
            },
            edit_participants() {
                console.log('false 1', 'group size ->', this.group_size, 'participants_fields', this.participants_fields);
                if(this.group_size < 2 || this.participants_fields.length < 1){
                    return false;
                }

                for (let i = 0; i < this.prestations.length; i++) {
                    if (this.prestations[i].is_group == 1 && this.prestations[i].allow_subgroup == 1
                        && (this.prestations[i].edit_participants == 1 || this.prestations[i].forced_to_edit_participants == 1)) {
                        return true;
                    }
                }
                return false;
            },
        },
        methods: {
            handleAttachmentUpdate(file) {
                this.attachment = file;
                this.$emit('update-attachment', file);
            },
            handleRemoveFile() {
                this.attachment = null
                this.$emit('update-attachment', null);
            },
            get_extfield_value(field){
                // console.log(field.data_type,this.rdv_data[field.internal_col_name],this.rdv_data);
                return this.rdv_data ? this.rdv_data[field.internal_col_name] : null;
            },
            has_presta_group(){
                return this.prestations[0].is_group;
            },
            add_participants_to_rdv_data(){
                this.rdv_data['participants'] = this.participants;
            },
            set_selected_participant(index){
                if(this.selectedParticipant == index){
                    this.selectedParticipant = null;
                }else{
                    this.selectedParticipant = index;
                }
            },
            addParticipant(){
                // Check participant count vs group size
                if (this.participants.length >= this.group_size - 1) {
                    this.error_message = `Vous ne pouvez ajouter que ${this.group_size - 1} participant(s) maximum.`;
                    return;
                }

                let participant = {};
                let data = this.validateDynamiqueFields('participants_bloc', this.participants_fields);

                if(data){
                    this.error_message = null;
                }else{
                    return false;
                }

                let inputFields = document.querySelectorAll(`#participants_bloc [field_name]`);
                for (const input of inputFields) {
                    const fieldName = input.getAttribute("field_name");
                    if (input.type === "checkbox") {
                        if (!participant[fieldName]) participant[fieldName] = [];
                        if (input.checked) participant[fieldName].push(input.value);
                    } else {
                        participant[fieldName] = input.value;
                    }
                    input.value = null;
                }
                this.participants.push(participant);
                this.add_participants_to_rdv_data();
                this.$emit('participants-modify', this.participants)
            },
            removeParticipant(index){
                this.participants.splice(index, 1);
                this.add_participants_to_rdv_data();
                this.$emit('participants-modify', this.participants)
            },
            setAttachment($event) {
                const file = $event.target.files[0];

                if (!file) {
                    this.attachment = null;
                    this.$emit('update-attachment', null);
                    return;
                }

                const size = file.size / 1024 / 1024;

                if (size <= 2) {
                    this.attachment = file;
                    this.$emit('update-attachment', file);
                } else {
                    this.attachment = null;
                    alert("Le fichier dépasse la taille maximale autorisée de 2 Mo.");
                    $event.target.value = null;
                    this.$emit('update-attachment', null);
                }
            },
            validateDynamiqueFields(bloc_id, presta_fields){
                // if (this.is_loading) return false

                let fields = document.querySelectorAll(`#${bloc_id} [field_name]`);

                let data = {}
                for (let field of fields) {
                    if (field.getAttribute('type') === 'checkbox' && !field.checked) continue;
                    let field_name = field.getAttribute('field_name');
                    let elt = data[field_name]||[];
                    if (field.value) elt.push(field.value);
                    data[field_name] = elt;
                }
                for (let key in data) {
                    let field = presta_fields.find(field => field.internal_col_name === key);
                    if (field.data_type !== "checkbox") data[key] = data[key].toString();
                    if (field.required && (!data[key] || (data[key]+"").trim() == "")) {
                        let field_name = field.name ? field.name?.toLowerCase() : null;
                        this.error_message =
                            field_name ?
                            `Le champ "${field_name}" est obligatoire.` :
                            "Merci de renseigner tous les champs obligatoires."
                        return false
                    }
                    if(field.data_type === 'date'){
                        let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                        if (result){
                            data[key] = `${result[3]}/${result[2]}/${result[1]}`
                        }else if(/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])){
                        }else{
                            let field_name = field.name.toLowerCase()
                            this.error_message =  `Le champ "${field_name}" doit être une date valide.`
                            return false
                        }
                    }
                }
                return data;
            },
            get_prestations_fields(){
                axios.get('/prestations/extrafields',{params: {ids: this.getSelectedPrestationsIds(), has_presta_group: this.has_presta_group()}}).then(response => {
                    this.prestations_fields = response.data['presta_ext_fields'].sort((a, b) => a.position - b.position);
                    this.participants_fields = response.data['attendee_presta_ext_fields'].sort((a, b) => a.position - b.position);
                })
            },
            getSelectedPrestationsIds(){
                return this.prestations.map(prestation => prestation.prestation_id);
            },
        },
        watch: {
            participants: {
                handler(newVal) {
                    const canSubmit = newVal.length === this.group_size - 1;
                    this.$emit('can-submit', canSubmit);
                },
                deep: true,
                immediate: true,
            }
        },
        mounted() {
            console.log('attendiesform component');
            window.scrollTo({ top: 0, behavior: 'smooth' }); // scroll
            this.get_prestations_fields();
            if(this.rdv_data.rdv_id){
                if(this.attendees) this.participants = this.attendees;
            }
        },
        updated(){
            // console.log('participants_fields', this.participants_fields);
            // console.log('participants', this.participants);
        }
    }

</script>

<style scoped>
    .nmb-3 {
        margin-bottom: -12px;
    }
    .required {
        color: #e53e3e;
    }
</style>